import React from 'react';
import { Divider, Typography } from '@mui/material';
import maserRog from '../../../../../images/Agri-info/fish/wound fish_মাছের রোগ.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const MaserRogInfo = () => {

    // dynamic title
    useDocumentTitle("মাছের রোগ");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h4"
                noWrap
                component="div"
            >
                মাছের রোগ
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={maserRog} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text"><b>মাছের রোগ বালাই নিরাময় ও প্রতিকার</b><br />রোগের নাম/আক্রান্ত মাছের প্রজাতি/রোগের লক্ষন ও কারণ/চিকিৎসা ও ঔষধ প্রয়োগ/প্রতিষেধক/প্রতিকার</p>
                            <p className="card-text"><b>১) রোগের নাম - ছত্রাক রোগ (সেপ্রোল্গেনিয়াসিস)</b><br />আক্রান্ত মাছের প্রজাতি - রুই জাতীয় ও অন্যান্য চাষ যোগ্য মাছ।</p>
                            <p className="card-text"><b>রোগের লক্ষন ও কারণ</b><br />
                                ক. আক্রান্ত মাছের ক্ষতস্থানে তুলার ন্যায় ছত্রাক দেখা দেয় এবং পানির স্রোত যখন স্থির হয়ে যায় কিংবা বদ্ধজলায় অথবা হ্যাচারী ট্যাংকে যেখানে অনিষিক্ত ডিমের ব্যাপক সমাগম ঘটে উহাতে ছত্রাক রোগ দ্রুত বিস্তৃতি লাভ করে। এমনি ধরনের প্রাকৃতিক জলাশয়ে প্রায় শতকরা ৯৮ ভাগ মাছের ডিম ক্ষতিগ্রস্ত হয়। সেপ্রোলেগনিয়া প্রজাতি এ রোগের কারণ।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p className="card-text"><b>চিকিৎসা ও ঔষধ প্রয়োগ</b><br />
                    ক. হ্যাচারিতে লালনকৃত ডিমগুলোকে ২৫০ পিপিএম পরমালিন দিয়ে ধৌত করা।<br />
                    খ. খাচা এবং পেনে চাষকৃত আক্রান্ত মাছগুলোকে শতকরা ৩-৫ ভাগ ফরমালিন দিয়ে ২-৩ মিনিট গোসল দেয়া।<br />
                    গ. বিকল্প হিসাবে শতকরা ৫ ভাগ লবন পানিতে গোসল দেয়া যেতে পারে।</p>
                <p className="card-text"><b>প্রতিষেধক/প্রতিকার</b><br />
                    ক. হ্যাচারীর প্রতিটি যন্ত্রপাতি ও ট্যাংক সম্পূর্ণরুপে পরিষ্কার করার পর শতকরা ১০ ভাগ ফরমালিন পানি দিয়ে ধৌত করা।<br />
                    খ. অনিষিক্ত ও মৃত ডিমগুলোকে অবিলম্বে হ্যাচারি ট্যাংক থেকে সরিয়ে নেয়া এবং অধিক খাদ্য প্রয়োগ না করা।</p>
                <p className="card-text"><b>২) রোগের নাম - মাছের ক্ষত রোগ (ইপিজুটিকআরসারেটিভসিনড্রোম )</b><br />
                    আক্রান্ত মাছের প্রজাতি - শোল, গজার, টাকি, পুঁটি, বাইম, কৈ, মেনি, মৃগেল, কার্পিও এবং তলায় বসবাসকারী অন্যান্য প্রজাতির মাছ।</p>
                <p className="card-text"><b>রোগের লক্ষন ও কারণ</b><br />ক. এ রোগের মুল কারণ এ্যাফানোমাইসিস ইনভাডেনস্ নামক ছত্রাক দ্ধারা মূলতঃ মাছের মাংসপেশী আক্রান্ত হয়। এছাড়া কিছু ব্যবকটিরিয়া, প্রোটোজোয়া সংশ্লিষ্ট আছে বলে জানা যায়। রোগাক্রান্ত হওয়ার পূর্বে পানির গুনাগুনের অবনতি ঘটে, যেমন ঃ</p>
                <p>i) হঠাৎ তাপমাত্রার কমতি (১৯° সেঃ এর কম)।<br />
                    ii) পি, এইচ-এর কমতি (৪-৬)।<br />
                    iii) এ্যালকালিনিটির কমতি (৪৫-৭৪ পিপিএম)।<br />
                    iv) হার্ডনেস-এর কমতি (৫০-৮০ পিপিএম)।<br />
                    v) ক্লোরাইড এর স্বল্পতা (৩-৬ পিপিএম)।</p>
                <p className="card-text"><b>চিকিৎসা ও ঔষধ প্রয়োগ</b><br />
                    ক. নিরাময়ের জন্য ০.০১ পিপিএম চুন ও ০.০১ পিপিএম লবন অথবা ৭-৮ ফুট গভীরতায় প্রতি শতাংশ জলাশয়ে ১ কেজি হারে চুন ও ১ কেজি হারে লবন প্রয়োগ করলে আক্রান্ত মাছগুলো ২ সপ্তাহের মধ্যে আরোগ্য লাভ করে।</p>
                <p className="card-text"><b>প্রতিষেধক/প্রতিকার</b><br />
                    ক. আগাম প্রতিকার হিসাবে আশ্বিন কার্তিক মাসে বর্ণিত হারে লবন ও চুনের প্রয়োগ করলে আসন্ন পরবর্তী শীত মৌসুমে মাছের ক্ষত রোগের প্রাদুর্ভাব থেকে অব্যাহতি পাওয়া যায়।</p>
                <p className="card-text"><b>৩) রোগের নাম - ক্ষত রোগ</b><br />আক্রান্ত মাছের প্রজাতি - সিলভার কার্প</p>
                <p className="card-text"><b>রোগের লক্ষন ও কারণ</b><br />ক. উপকূলীয় অঞ্চলে মাছ চাষের পুকুর বন্যায়প্লাবিত হলে ক্লোরাইডের অস্বাভাবিক বৃদ্ধির (৩০ পিপিএম এর অধিক) ফলে কেবল মাত্র সিলভার কার্প মাছে দ্রুত ক্ষত রোগ দেখা দেয়।</p>
                <p className="card-text"><b>চিকিৎসা ও ঔষধ প্রয়োগ</b><br />
                    ক. আক্রান্ত পুকুরে তিন ভাগের দুই ভাগ পানি মিঠাপানির দ্ধারা পরিবর্তন করা।  <br />
                    খ. প্রতি শতাংশ জলাশয়ে ৩/৪টি হারে চালতা ছেঁচে সারা পুকুরে ছড়িয়ে দিতে হবে।</p>
                <p className="card-text"><b>প্রতিষেধক/প্রতিকার</b><br />
                    ক. বর্ণিতহারে চালতা প্রয়েগের ফলে ক্ষতরোগ আক্রান্ত সিলভার কার্প দ্রুত আরোগ্য লাভ করে।<br />
                    খ. পুকুরকে বন্যামুক্ত রাখুন।</p>
                <p className="card-text"><b>৪) রোগের নাম -পাখনা অথবা লেজ পঁচা রোগ</b><br />
                    আক্রান্ত মাছের প্রজাতি - রুই জাতীয় মাছ, শিং মাগুর ও পাঙ্গাস মাছ।</p>
                <p className="card-text"><b>রোগের লক্ষন ও কারণ</b><br />
                    ক. প্রাথমিক ভাবে পিঠের পাখনা এবং ক্রমান্বয়ে অন্যান্য পাখনা আক্রান্ত হয়। এ্যারোমোনাড্স ও মিক্সোব্যাকটার গ্রুপের ব্যাকটেরিযা দ্ধারা এ রোগের সৃষ্টি হয়।<br />
                    খ. পানির পি-এইচ ও ক্ষরতার স্বল্পতা দেখা দিলে এ রোগ দেখা দিতে পারে।</p>
                <p className="card-text"><b>চিকিৎসা ও ঔষধ প্রয়োগ</b><br />
                    ক. ০৫ পিপিএম পটাশযুক্ত পানিতে আক্রান্ত মাছকে ৩-৫ মিনিট গোসল করাতে হবে।<br />
                    খ. পুকুরে সার প্রয়োগ বন্ধ রাখতে হবে।</p>
                <p className="card-text"><b>প্রতিষেধক/প্রতিকার</b><br />
                    ক. রোগজীবানু ধ্বংসের পর মজুদকৃত মাছের সংখ্যা কমাবেন।   <br />
                    খ. প্রতি শতাংশে ১ কেজি হারে চুন প্রয়োগ করুন।</p>
                <p className="card-text"><b>৫) রোগেরনাম - পেটফোলারোগ</b><br />
                    আক্রান্ত মাছের প্রজাতি - রুই জাতীয় মাছ, শিং মাগুর ও পাঙ্গাস মাছ।</p>
                <p className="card-text"><b>রোগের লক্ষন ও কারণ</b><br />
                    ক. মাছের দেহের রং ফ্যাকাশে হয়ে যায় এবং পানি ও সঞ্চালনের মাধ্যমে পেট ফুলে যায়।<br />
                    খ. মাছ ভারসাম্যহীনভাবে চলাচল করে এবং পানির ওপর ভেসে থাকে । অচিরেই আক্রান্ত মাছের মৃত্যু ঘটে।<br />
                    গ.  এ্যারোমোনাড্স ব্যাকটেরিয়া এ রোগের কারণ।</p>
                <p className="card-text"><b>চিকিৎসা ও ঔষধ প্রয়োগ</b><br />
                    ক. খালী সিরিঞ্জ দিয়ে মাছের পেটের পানিগুলো বের করে নিতে হবে। প্রতি কেজি মাছের জন্য ২৫ মিঃ গ্রাঃ হারে ক্লোরেমফেনিকল ইনজেকশন দিতে হবে। অথবা,
                    খ. প্রতি কেজি খাবারের সাথে ২০০ মিঃ গ্রাঃ ক্লোরেমফেনিকল পাউডার মিশিয়ে সরবরাহ করা।</p>
                <p className="card-text"><b>প্রতিষেধক/প্রতিকার</b><br />
                    ক. পট্রতি শতাংশ জলাশয়ে ১ কেজি হারে চুন প্রয়োগ করুন।<br />
                    খ. মাছের খাবারের সাথে ফিশমিল ব্যবহার করুন।<br />
                    গ. মাছকে সুষম খাদ্য সরবরাহ করবেন।<br />
                    ঘ. প্রাকৃতিক খাবার হিসেবে প্লাংকটনের স্বাভাবিক উৎপাদন নিশ্চিত করুন।</p>
                <p className="card-text"><b>৬) রোগের নাম - সাদা দাগ রোগ</b><br />আক্রান্ত মাছের প্রজাতি - মৃগেল ও রুই মাছের পোনা।</p>
                <p className="card-text"><b>রোগের লক্ষন ও কারণ</b><br />
                    ক. পোনা মাছের আঁইশ, পাখনাসহ সারা দেহে ক্ষুদ্র ক্ষুদ্র সাদা দাগ দেখা দেয়<br />
                    খ. প্রায় ২ সপ্তাহকালীন সময় অব্যাহত থাকে।<br />
                    গ. এ রোগ ব্যাকটেরিয়া জনিত।</p>
                <p className="card-text"><b>চিকিৎসা ও ঔষধ প্রয়োগ</b><br />ক. মাছের সংখ্যা কমিয়ে পানির প্রবাহ বৃদ্ধি করা। জীবানু মুক্ত পানিতে দুই সপ্তাহের মধ্যে মাছ স্বাভাবিকভাবেই আরোগ্য লাভ করে। বিশেষ কোন চিকিৎসার প্রয়োজন নেই।</p>
                <p className="card-text"><b>প্রতিষেধক/প্রতিকার</b><br />ক. চুন প্রয়োগের মাধ্যমে পোনা মাছের লালন পুকুর প্রস্তুত করলে এ রোগের প্রাদুর্ভাব এড়ানো যায়।</p>
                <p className="card-text"><b>রোগের লক্ষন ও কারণ</b><br />ক. মিক্সো-বোলাস প্রজাতির এককোষী প্রাণী রুই জাতীয় মাছের বিশেষ করে কাতলা মাছের ফুলকার উপরে সাদা কিংবা হালকা বাদামী গোলাকার গুটি তৈরী করে বংশ বৃদ্ধি করতে থাকে। ক্রমান্বয়ে ঐ গুটির প্রভাবে ফুলকায় ঘা দেখা যায় এবং ফুলকা খসে পড়ে। শ্বাসপ্রশ্বাসের ব্যাঘাত সৃষ্টিতে মাছ অস্থিরভাবে ঘোরাফেরা করে এবং খাবি খায়। শেষ রাতের দিকে ব্যাপক মড়ক দেখা যায়।</p>
                <p className="card-text"><b>চিকিৎসা ও ঔষধ প্রয়োগ</b><br />
                    ক. অদ্যাবধি এই রোগের সরাসরি কোন চিকিৎসা আবিষ্কৃত হয় নাই।<br />
                    খ. তথাপিও প্রতি শতাংশ জলাশয়ে ১ কেজি হারে চুন প্রয়োগ করলে পানির গুনাগুন বৃদ্ধি পেয়ে অম্লত্ব দূর হয়। পরজীবিগুলো ক্রমান্বয়ে অদৃশ্য হয়ে যায় এবং মাছ নিষ্কিৃতি লাভ করে।</p>
                <p className="card-text"><b>প্রতিষেধক/প্রতিকার</b><br />ক. পুকুর প্রস্তুতকালীন প্রতি শতাংশ জলাশয়ে ১ কেজি হারে চুন প্রয়োগ করে মাটি শোধন করা হলে আসন্ন মৌসুমে এ রোগের প্রকোপ থাকে না।</p>

            </div>
        </div >


    );
};

export default MaserRogInfo;